import { createContext } from "react";
import type { AppModule } from "./appModules";
import type { StartLoginOptions } from "./session";
import type { AuthStatus, Me, Role } from "./types";

export interface AuthContextValue {
  status: AuthStatus;
  /** Profile from GET /v1/me; null until signed in. */
  me: Me | null;
  /** The user's platform roles (automatic Cognito groups excluded). */
  roles: Role[];
  hasRole: (...roles: Role[]) => boolean;
  isPlatformAdmin: boolean;
  /** Signed in but no role yet: waiting for a platform admin. */
  isPending: boolean;
  /** Pages the user may open, from their access groups (the API checks the same). */
  modules: AppModule[];
  hasModule: (module: AppModule) => boolean;
  login: (options?: StartLoginOptions) => Promise<void>;
  signup: (options?: StartLoginOptions) => Promise<void>;
  logout: () => Promise<void>;
  /** Called by /auth/callback once the session exists. */
  completeSignIn: () => Promise<void>;
  /** Renew the access token and re-read /v1/me (e.g. after an admin granted a role). */
  reloadMe: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
